<div class="container">
  <div class="icon-container">
    <rd-shared-icon
      [iconSymbol]="getIconSymbol()"
      [iconTheme]="'error'"></rd-shared-icon>
  </div>
  <h1
    *ngIf="shouldRenderCheckoutErrorDialogTitle"
    class="title"
    [innerHTML]="dialogConfig.data.errorMessageTitle"></h1>
  <p
    class="description"
    [innerHTML]="dialogConfig.data.errorMessageDescription"></p>
  <div class="button-wrapper button-height">
    <rd-shared-button
      class="ok-button"
      [buttonClass]="'ok-button'"
      [buttonContent]="okButtonContent"
      [buttonTheme]="buttonTheme"
      (clickFn)="handleClick()">
      <ng-template #okButtonContent>
        <span class="ok-button-text">{{
          dialogConfig.data.ctaButtonText
        }}</span>
      </ng-template>
    </rd-shared-button>
  </div>
</div>
